import Vue from 'vue'

const ModalConstructor = Vue.extend(require('./modal.vue'))
const instances = []

export default function Modal(opts) {
  const instance = getInstance()
  const options = opts || {
    title: '',
    msg: '',
    link: {
      title: opts.title || '用户已存在，不可重复申请',
      msg: opts.msg || '为您推荐这款贷款产品，点击查看：',
      link: opts.link || {
        title: '额度宝',
        desc: '凭身份证就能贷<br>10万秒下款',
        url: '',
        img: reuqire('../../../../img/xhpopulrz/common/edb.png')
      }
    }
  }

  instance.title = options.title || ''
  instance.msg = typeof options === 'string' ? options : options.msg
  instance.link = options.link
  instances.push(instance)
  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.open()
  })
}

function getInstance() {
  if (instances.length > 0) {
    const instance = instances[0]
    instances.splice(0, 1)
    return instance
  }

  return new ModalConstructor({
    el: document.createElement('div')
  })
}



// WEBPACK FOOTER //
// ./web/js/xhpopulrz/util/modal/modal.js